import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class NominationsContainer extends ShadowDOMElement {
	static className = "NominationsContainer";
	
	render() {
    return html`
      <title-field label="Nominations"></title-field>
      <checkbox-field
        label="Premiers membres du Conseil de surveillance"
		id="chk-premiers"
        @change="${this.toggleVisibility.bind(this, "main-container")}"
      ></checkbox-field>
      <div-container id="main-container" visible="false">
        <row-wrapper>
          <text-field label="Nombre d'exercices *" required name="number_of_exercises" disable-autocomplete></text-field>
        </row-wrapper>
        <checkbox-field
          label="Personne physique"
		  id="chk-physique"
          @change="${this.toggleVisibility.bind(this, "personne-physique-list-container")}"
        ></checkbox-field>
        <div-container id="personne-physique-list-container" visible="false">
          <personne-physique-list
          ></personne-physique-list>
        </div-container>
        <checkbox-field
          label="Personne morale"
		  id="chk-morale"
          @change="${this.toggleVisibility.bind(this, "personne-morale-extended-list-container")}"
        ></checkbox-field>
        <div-container id="personne-morale-extended-list-container" visible="false">
          <personne-morale-extended-list greffe="false"></personne-morale-extended-list>
        </div-container>
        <subtitle-field label="Première réunion du conseil de surveillance"></subtitle-field>
        <row-wrapper>
          <date-field label="Date *" required name="date"></date-field>
        </row-wrapper>
        <row-wrapper>
          <text-field label="Lieu *" required name="location"></text-field>
        </row-wrapper>
        <subtitle-field label="Ont été nommés"></subtitle-field>
        <checkbox-field
          label="Président du directoire"
		  id="chk-president"
          @change="${this.toggleVisibility.bind(this, "president-container")}"
        ></checkbox-field>
        <personne-physique
          id="president-container"
          visible="false"
        ></personne-physique>
        <checkbox-field
          label="Vice-président"
		  id="chk-vice-president"
          @change="${this.toggleVisibility.bind(this, "vice-president-container")}"
        ></checkbox-field>
        <personne-physique
          id="vice-president-container"
          visible="false"
        ></personne-physique>
        <checkbox-field
          label="Président du conseil de surveillance"
		  id="chk-council"
          @change="${this.toggleVisibility.bind(this, "president-council-container")}"
        ></checkbox-field>
        <personne-container
          id="president-council-container"
		  name="president-council-container"
          visible="false"
        ></personne-container>
        <checkbox-field
          label="Membres du directoire"
		  id="chk-board"
          @change="${this.toggleVisibility.bind(this, "membres-directoire-container")}"
        ></checkbox-field>
        <div-container id="membres-directoire-container" visible="false">
          <personne-physique-list
          ></personne-physique-list>
        </div-container>
      </div-container>
    `;
	}

	toggleVisibility (containerId, event) {
		const container = this.shadowRoot.querySelector(`#${containerId}`);
		if (container)
			container.visible = event.target.checked;
	}
	
	isTransient (){
		return false;
	}

	#updateContainers (){
		[
			{chk : "chk-premiers", div : "main-container"},
			{chk : "chk-physique", div : "personne-physique-list-container"},
			{chk : "chk-morale", div : "personne-morale-extended-list-container"},
			{chk : "chk-president", div : "president-container"},
			{chk : "chk-vice-president", div : "vice-president-container"},
			{chk : "chk-council", div : "president-council-container"},
			{chk : "chk-board", div : "membres-directoire-container"}
		].forEach (item => {
			const visible = this.shadowRoot.querySelectorAll ("#" + item.chk)[0].checked;
			this.shadowRoot.querySelectorAll ("#" + item.div)[0].visible = visible;
		});
	}

	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}
}

customElements.define ("nominations-container", NominationsContainer);
